import React, { useEffect, useRef, useState } from "react";
import { FaRegEye } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useViewActivity } from "../../hooks/reports/activity";
import Pagination from "./pagination";

const RecentActivity = () => {
  const dropdownRefs = useRef({});
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [page, setPage] = useState(1);
  const limit = 200;
  const [activity, setActivity] = useState([]);
  const navigate = useNavigate();
  const { data, isLoading, error, refetch, isFetching } = useViewActivity(page, limit);

  console.log("activity data", data);

  useEffect(() => {
    const intervalId = setInterval(() => {
      refetch();
    }, 5000);
    return () => clearInterval(intervalId);
  }, [refetch]);

  useEffect(() => {
    const apiData = Array.isArray(data?.data?.data) ? data.data.data : [];
    // console.log("raw activity data", apiData);
    const sorted = apiData
      .slice()
      .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
    setActivity(sorted);
  }, [data]);

  const totalDocs = data?.data?.pagination?.totalDocs || 0;
  const totalPages = data?.data?.pagination?.totalPages || Math.ceil(totalDocs / limit) || 1;
  const rangeStart = totalDocs > 0 ? (page - 1) * limit + 1 : 0;
  const rangeEnd = Math.min(page * limit, totalDocs);

  return (
    <div className="recent-activity-container" style={{
      background: '#fff',
      borderRadius: 12,
      boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
      padding: 24,
      margin: 0,
      width: '100%',
      minWidth: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 24,
      maxWidth: '100vw',
      overflow: 'auto',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 18 }}>
        <h3 style={{ margin: 0, fontWeight: 600, fontSize: 22, color: '#1a237e', letterSpacing: 0.2 }}>Recent Activity</h3>
      </div>
      <div style={{ width: '100%', overflowX: 'auto' }}>
        {isLoading ? (
          <div style={{ padding: 32, textAlign: 'center', color: '#888' }}>Loading...</div>
        ) : error ? (
          <div style={{ padding: 32, textAlign: 'center', color: '#d32f2f' }}>{error.message || 'Failed to fetch activity'}</div>
        ) : (
          <table style={{ minWidth: 600, width: '100%', borderCollapse: 'separate', borderSpacing: 0, background: '#fafbfc', borderRadius: 8, overflow: 'hidden', boxShadow: '0 1px 4px rgba(60,72,88,0.04)' }}>
            <thead>
              <tr style={{ background: '#e3eafc', color: '#1a237e', fontWeight: 700 }}>
                <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 600, fontSize: 15, borderBottom: '1px solid #e0e0e0', minWidth: 120 }}>User</th>
                <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 600, fontSize: 15, borderBottom: '1px solid #e0e0e0', minWidth: 120 }}>Distributer</th>
                <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 600, fontSize: 15, borderBottom: '1px solid #e0e0e0', minWidth: 100 }}>Country</th>
                <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 600, fontSize: 15, borderBottom: '1px solid #e0e0e0', minWidth: 120 }}>Actions</th>
                <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 600, fontSize: 15, borderBottom: '1px solid #e0e0e0', minWidth: 180 }}>Time</th>
              </tr>
            </thead>
            <tbody>
              {activity.length === 0 ? (
                <tr>
                  <td colSpan={5} style={{ padding: 24, textAlign: 'center', color: '#888' }}>No recent activity found.</td>
                </tr>
              ) : (
                activity.map((item, idx) => (

                  console.log("activity item", item) ||
                  <tr key={item._id} style={{ background: idx % 2 === 0 ? '#fff' : '#f4f6fa', transition: 'background 0.2s' }}>
                    <td style={{ padding: '12px 16px', fontWeight: 500, color: '#222', wordBreak: 'break-word' }}>{item.distributorId?.contactPerson || 'N/A'}</td>
                    <td style={{ padding: '12px 16px', fontWeight: 500, color: '#222', wordBreak: 'break-word' }}>{item.distributorId?.companyName?.companyName || 'N/A'}</td>
                    <td style={{ padding: '12px 16px', color: '#444', wordBreak: 'break-word' }}>{item.distributorId?.country || 'N/A'}</td>
                    <td style={{ padding: '12px 16px', color: '#444', textTransform: 'capitalize', wordBreak: 'break-word' }}>{item?.action || 'N/A'}</td>
                    <td style={{ padding: '12px 16px', color: '#666', fontSize: 14, wordBreak: 'break-word' }}>{new Date(item.timestamp).toLocaleString()}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>

      {activity.length > 0 && (
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: 20,
          paddingTop: 16,
          borderTop: '1px solid #eee',
          flexWrap: 'wrap',
          gap: 12
        }}>
          <div style={{ fontSize: 14, color: '#666', fontWeight: 500 }}>
            Showing {rangeStart}-{rangeEnd} of {totalDocs} activities
          </div>
          <Pagination
            currentPage={page}
            totalPages={totalPages}
            onPageChange={(nextPage) => setPage(nextPage)}
          />
        </div>
      )}
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default RecentActivity;